
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { post, get } from '../../helpers/api_helper';
import { POST_UPDATE_SETTING, GET_ALL_SETTING } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import useMounted from '../../hooks/useMounted';
import Loader from '../../components/Loader';

const Setting = (props) => {

    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState();


    useMounted(() => {
        async function get_detaile() {
            await get_app_setting();
            setLoader(1);
        }
        get_detaile();
    }, [])


    const get_app_setting = async () => {
        var res_data = await get(GET_ALL_SETTING + "?type=common-setting");
        if (res_data.status) {
            await setInputs(res_data.data);
        } else {
            toast.error(res_data.message);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();

        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_SETTING, form_inputs, {});
        if (res_data.status) {
            await get_app_setting();
            toast(res_data.message);
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChange = (event) => {

        if (event.target.name === 'signup_enable' || event.target.name === 'signin_enable') {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: (event.target.checked) ? 1 : 0 }));
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Common Setting</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <div className="form-check form-switch mb-2">
                                        <label className="form-check-label" htmlFor="checkbox1">Signup Enabled</label>
                                        <input className="form-check-input" defaultChecked={parseInt(form_inputs.signup_enable)} name='signup_enable' onChange={handleInputChange} type="checkbox" id="checkbox1" />
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <div className="form-check form-switch mb-2">
                                        <label className="form-check-label" htmlFor="checkbox2">Signin Enabled</label>
                                        <input className="form-check-input" defaultChecked={parseInt(form_inputs.signin_enable)} name='signin_enable' onChange={handleInputChange} type="checkbox" id="checkbox2" />
                                    </div>
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Vat %</label>
                                    <input name="vat_percentage" maxLength={2} value={form_inputs.vat_percentage} onChange={handleInputChange} className="form-control" placeholder={`Enter vat Percentage`} type="text" />
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Contact Us Inquiry Received Email</label>
                                    <input name="contact_us_inquiry_received_email" value={form_inputs.contact_us_inquiry_received_email} onChange={handleInputChange} className="form-control" placeholder={`Enter Email Address`} type="text" />
                                </div>
                                <div className='text-center mt-5'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Update
                                    </button>
                                    <Link to="/setting" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;